import styles from './ButtonBox.module.css';

interface ButtonBoxProps extends React.HTMLAttributes<HTMLDivElement> {}

const ButtonBox = ({ className, ...props }: ButtonBoxProps): React.JSX.Element => (
    <div className={`${styles.buttonBox}${className ? ` ${className}` : ''}`} {...props} />
);

export { ButtonBox };
